module.exports = __webpack_public_path__ + "fonts/LineIconsPro Regular.2d96c6c.ttf";